<template>
  <div class="padding no-padding-bottom">
    <div
      v-if="selectedWorker != null"
      class="content-trabajador-header"
    >
      <img
        v-if="photoProfileSubject == null && !uploadingPhotoProfileSubject"
        src="@/static/icons/ic_user.svg"
        class="avatar"
      >
      <img
        v-if="photoProfileSubject != null"
        :src="photoProfileSubject"
        class="avatar"
      >
      <span v-if="uploadingPhotoProfileSubject">
        {{ $t('common.loading') }}
      </span>

      <div>
        <span class="main-title">{{ selectedWorker.Sujeto.NombreSujeto }}</span>
        <span>{{ selectedWorker.Codigo }} </span>
      </div>
    </div>
  </div>
</template>

<script>
import { callGetPhotosProfileSubjects } from '@/js/services/APIErp';

export default {
  name: 'PCWorkerPresenceCard',

  props: {
    selectedWorker: { type: Object, default: null },
  },
  data() {
    return {
      uploadingPhotoProfileSubject: false,
      photoProfileSubject: null,
    };
  },
  created() {
    this.GetPhotosProfileSubjects();
  },

  methods: {
    GetPhotosProfileSubjects() {
      if (this.selectedWorker != null
        && this.selectedWorker.Sujeto.ImagenPerfil === null) {
        this.uploadingPhotoProfileSubject = true;
        this.Conections_GetPhotosProfileSubjects(this.selectedWorker.Sujeto).then((data) => {
          if (data.length > 0) {
            this.photoProfileSubject = data[0].ImagenPerfil?.Archivo;
          }
        }).finally(() => {
          this.uploadingPhotoProfileSubject = false;
        });
      }
      if (this.selectedWorker != null
        && this.selectedWorker.Sujeto.ImagenPerfil != null) {
        this.photoProfileSubject = this.selectedWorker.Sujeto.ImagenPerfil.Archivo;
      }
    },
    /* ********************************************************* */
    /* ****************** CONNECTIONS  ********************* ** */
    /* ********************************************************* */
    Conections_GetPhotosProfileSubjects(objSubjects) {
      return new Promise((resolve, reject) => {
        callGetPhotosProfileSubjects([objSubjects])
          .then((result) => {
            resolve(result.data);
          }).catch((error) => {
            // eslint-disable-next-line no-console
            console.error(error);
            reject();
          });
      });
    },
  },
};
</script>

<style lang="scss">
.content-trabajador-header {
  display: flex;
  align-items: center;

  div {
    display: flex;
    flex-direction: column;
    padding-left: 15px;

    span {
      color: var(--his-dark-blue);

      &.main-title {
        font-size: 16px;
        font-weight: 600;
        color: var(--his-dark-blue);
      }
    }
  }
}
</style>
